import * as pdfMake from 'pdfmake/build/pdfmake'
import * as pdfFonts from 'pdfmake/build/vfs_fonts'
import { safeLogo } from './img/safe-logo'
import { formS1776, formS1585, formS1627, formS1628, formS1629, formS1775, formS1778 } from './forms'
import { format } from 'date-fns'
import { Payload } from '../types'
import { capitalize } from '../helpers'
;(pdfMake.vfs as any) = pdfFonts.pdfMake.vfs

const genPdfBody = (form: string, extensionDate: string): any[] => {
  if (form === '1585') return formS1585()
  if (form === '1628a') return formS1628()
  if (form === '1629a' || form === '1629b') return formS1629(form)
  if (form === '1776') return formS1776()
  if (form === '1775') return formS1775()
  if (form === '1778') return formS1778()
  return formS1627(extensionDate)
}

const genFooterDate = (form: string): string => {
  switch (form) {
    case '1585':
    case '1628a':
    case '1629a':
    case '1629b':
    case '1627a':
    case '1776':
    case '1775':
    case '1778':
      return '1/1/2023'
    default:
      return ''
  }
}

export const genPdf = async (payloadState: Payload): Promise<any> => {
  const { responseForm } = payloadState
  const date = format(new Date(), 'MMMM dd, yyyy')
  const extensionDate = payloadState.dateExtension
  let middleName = ' '
  if (payloadState?.consumerMiddleName) middleName = ` ${capitalize(payloadState?.consumerMiddleName)} `
  let suffix = ''
  if (payloadState?.consumerSuffix) suffix = ` ${capitalize(payloadState?.consumerSuffix)}`

  const fullName = `${capitalize(payloadState.consumerFirstName)}${middleName}${capitalize(payloadState.consumerLastName)}${suffix}`

  //agent
  let agentMiddleName = ' '
  if (payloadState?.agentMiddleName) agentMiddleName = ` ${capitalize(payloadState?.agentMiddleName)} `
  let agentSuffix = ''
  if (payloadState?.agentSuffix) agentSuffix = ` ${capitalize(payloadState?.agentSuffix)}`

  let agentFullName = null
  if (payloadState?.onBehalf === 'Yes' && !!payloadState?.agentFirstName && !!payloadState?.agentLastName) {
    agentFullName = `c/o ${capitalize(payloadState.agentFirstName)}${agentMiddleName}${capitalize(payloadState.agentLastName)}${agentSuffix}`
  }
  
  //address
  let addressLine2 = payloadState?.consumerAddressLine2 ?? null
  if (payloadState?.onBehalf === 'Yes') {
    addressLine2 = payloadState?.agentAddressLine2 ?? null
  }
  const consumerCityStateZip = `${payloadState.consumerCity}, ${payloadState.consumerState}  ${payloadState.consumerZip}`
  let agentCityStateZip = null
  if (payloadState?.onBehalf === 'Yes') {
    agentCityStateZip = `${payloadState.agentCity}, ${payloadState.agentState}  ${payloadState.agentZip}`
  }

  const dd: any = {
    info: { title: 'CCPA' },
    pageSize: 'LETTER',
    pageMargins: [58, 25, 58, 50],
    defaultStyle: { alignment: 'justify' },
    content: [
      { image: safeLogo, width: 100, marginBottom: 30 },
      { text: date, width: '*', marginBottom: 30 },
      { text: fullName },
      { text: `${payloadState.onBehalf === 'Yes' && agentFullName ? agentFullName : ''}` },
      { text: `${payloadState.onBehalf === 'No' ? payloadState.consumerStreetAddress : payloadState.agentStreetAddress}` },
      { text: `${addressLine2 ? addressLine2 : ''}` },
      { text: `${payloadState.onBehalf === 'No' ? consumerCityStateZip : agentCityStateZip}`, marginBottom: 30 },
      { text: `Dear ${fullName}:`, marginBottom: 5 },
      ...genPdfBody(responseForm, extensionDate)
    ],
    footer: [
      { text: '2295 Iron Point Road, Suite 100, Folsom CA 95630-8765 * (916) 979-7233 * (800) SEE-SAFE * www.safecu.org', fontSize: 8, marginLeft: 110 },
      { text: `S-${responseForm.toUpperCase()}    ${genFooterDate(responseForm)}`, fontSize: 8, marginLeft: 70, marginTop: 5 }
    ]
  }

  pdfMake.createPdf(dd).download(responseForm)
}
